export enum UserState {
  REQUESTED = "requested",
  APPROVED = "approved",
  DECLINED = "declined",
  REVOKED = "revoked",
}

export enum UserRole {
  USER = "user",
  DEV = "dev",
  QA = "qa",
  ADMIN = "admin",
}

export interface User {
  id: string;
  email: string;
  state: UserState;
  role: UserRole;
  user_note: string;
}

export interface UserDetail {
  id: string;
  created_at: string;
  email: string;
  state: UserState;
  role: UserRole;
  user_note: string;
  comments: string;
  last_login: string;
}

export interface IUserDetailResponse extends UserDetail {
  create_date: { value: string };
}

export interface AccessRequestPayload {
  email: string;
  state: UserState;
  role: UserRole;
  userNote: string;
  comments: string;
}

export interface UpdateAccessPayload {
  id: string;
  state: UserState;
  role: UserRole;
  comments: string;
}
